import { RefObject, useLayoutEffect, useMemo, useState } from "react";
import useGetVoucherCardShape from "dds4/hooks/useCreateVoucherCardBackground/v1/useCreateVoucherCardBackground";
import { getCssVar } from "src/utility";
import { NOTCH_RADIUS } from "../../../constants";

export default function useSharedVoucherShape() {
  const [seamEl, setSeamEl] = useState<HTMLDivElement | null>(null);
  const [seamY, setSeamY] = useState(0);

  useLayoutEffect(() => {
    if (!seamEl) return;
    const observer = new ResizeObserver(([entry]) => setSeamY(entry.borderBoxSize[0].blockSize));
    observer.observe(seamEl);
    return () => observer.disconnect();
  }, [seamEl]);

  const notches = useMemo(
    () =>
      seamY
        ? [
            { position: { x: 0, y: seamY }, radius: NOTCH_RADIUS },
            { position: { x: 100, y: seamY }, radius: NOTCH_RADIUS },
          ]
        : [],
    [seamY, seamEl],
  );

  const lines = useMemo(
    () => (w: number) =>
      seamY
        ? [
            {
              from: { x: 0, y: seamY },
              to: { x: w, y: seamY },
              style: "dashed" as const,
              color: getCssVar("--color-border-default"),
              width: 0.5,
            },
          ]
        : [],
    [seamY, seamEl],
  );

  const { ref, src } = useGetVoucherCardShape({
    notches,
    lines,
    fillColor: "var(--color-background-default)",
    borderColor: getCssVar("--color-border-default"),
    borderStyle: "solid",
    strokeWidth: 1,
    borderRadius: 10,
  });

  return { shapeRef: ref as RefObject<HTMLDivElement>, seamRef: setSeamEl, src };
}
